module.exports = __webpack_public_path__ + "img/comunidade.47839f6a.svg";